import { useEffect, useMemo, useState } from "react";
import { FaPlay } from "react-icons/fa6";
import { blurHashToDataUrl } from "../utils/blurHashPaint";

const MEDIA_TYPES = new Set(["image", "gif", "video", "circle"]);

export function isChatListMediaType(type?: string | null) {
  return MEDIA_TYPES.has(String(type || ""));
}

type Props = {
  messageType?: string | null;
  thumbUrl?: string | null;
  blurHash?: string | null;
  deleted?: boolean;
  className?: string;
  sizeClassName?: string;
};

/**
 * Telegram-style ~20px square last-message thumb for chat list.
 */
export default function ChatListMediaThumb({
  messageType,
  thumbUrl,
  blurHash,
  deleted = false,
  className = "",
  sizeClassName = "h-5 w-5",
}: Props) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  const src = String(thumbUrl || "").trim();
  const show = !deleted && isChatListMediaType(messageType) && (!!src || !!blurHash);

  const blurUrl = useMemo(
    () => (blurHash ? blurHashToDataUrl(blurHash, 16, 16) : null),
    [blurHash],
  );

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
  }, [src]);

  if (!show) return null;

  return (
    <span
      className={`relative inline-block shrink-0 overflow-hidden rounded-[3px] bg-[#3a3a3a] ${sizeClassName} ${className}`}
      aria-hidden
    >
      {blurUrl && !loaded ? (
        <img
          src={blurUrl}
          alt=""
          draggable={false}
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : null}
      {src && !failed ? (
        <img
          src={src}
          alt=""
          draggable={false}
          loading="lazy"
          decoding="async"
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-150 ${
            loaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
        />
      ) : null}
      {messageType === "video" || messageType === "circle" ? (
        <span className="absolute inset-0 grid place-content-center bg-black/25">
          <FaPlay
            className={`${
              sizeClassName.includes("h-10") ? "h-3 w-3" : "h-2 w-2"
            } text-white drop-shadow`}
          />
        </span>
      ) : null}
    </span>
  );
}
